import { render, staticRenderFns } from "./ProgresoDiarioTab.vue?vue&type=template&id=1830ccb6&"
import script from "./ProgresoDiarioTab.vue?vue&type=script&lang=js&"
export * from "./ProgresoDiarioTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports